import React, { cloneElement } from 'react';
import { BookOpen, Dumbbell, Calendar, ShieldAlert, Apple, BrainCircuit, Medal } from 'lucide-react';
import { FadeIn } from './ui/FadeIn';
export function ProductBreakdown() {
  const items = [{
    icon: <BrainCircuit data-id="element-176" />,
    text: 'Mentalidad runner (cómo dejar de abandonar)'
  }, {
    icon: <Dumbbell data-id="element-177" />,
    text: 'Preparación física desde cero'
  }, {
    icon: <Calendar data-id="element-178" />,
    text: 'Plan completo de 8 semanas paso a paso'
  }, {
    icon: <ShieldAlert data-id="element-179" />,
    text: 'Sistema anti-excusas'
  }, {
    icon: <Apple data-id="element-180" />,
    text: 'Alimentación simple para rendir mejor'
  }, {
    icon: <BookOpen data-id="element-181" />,
    text: 'Técnicas mentales para no rendirte'
  }, {
    icon: <Medal data-id="element-182" />,
    text: 'Cómo correr tu primer 5K y mantener el hábito'
  }];
  return <section className="bg-white py-20 md:py-32 overflow-hidden" data-id="element-183">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-184">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20" data-id="element-185">
          {/* Text Content */}
          <div className="w-full lg:w-1/2" data-id="element-186">
            <FadeIn data-id="element-187">
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-black text-dark mb-10" data-id="element-188">
                ¿Qué incluye{' '}
                <span className="text-primary" data-id="element-189">5K SIN RENDIRSE</span>?
              </h2>
            </FadeIn>

            <div className="space-y-4 mb-10" data-id="element-190">
              {items.map((item, index) => <FadeIn key={index} delay={index * 0.05} direction="right" data-id="element-191">
                  <div className="flex items-center gap-4 bg-light p-4 rounded-xl border border-gray-100 hover:border-primary/30 transition-colors" data-id="element-192">
                    <div className="bg-primary text-white p-2.5 rounded-lg flex-shrink-0" data-id="element-193">
                      {cloneElement(item.icon as React.ReactElement, {
                    className: 'w-5 h-5'
                  })}
                    </div>
                    <p className="text-lg text-gray-800 font-medium" data-id="element-194">
                      {item.text}
                    </p>
                  </div>
                </FadeIn>)}
            </div>

            <FadeIn delay={0.4} data-id="element-195">
              <p className="text-xl font-bold text-dark bg-green-50 p-6 rounded-xl border border-green-100 inline-block w-full text-center" data-id="element-196">
                👉 Todo explicado de forma simple, clara y aplicable.
              </p>
            </FadeIn>
          </div>

          {/* Image */}
          <div className="w-full lg:w-1/2" data-id="element-197">
            <FadeIn delay={0.2} direction="left" data-id="element-198">
              <div className="relative" data-id="element-199">
                {/* Decorative background blobs */}
                <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[120%] h-[120%] bg-primary/5 rounded-full blur-3xl -z-10" data-id="element-200"></div>

                <div className="grid grid-cols-2 gap-4" data-id="element-201">
                  <img src="https://images.unsplash.com/photo-1461896836934-ffe607ba8211?auto=format&fit=crop&w=600&q=80" alt="Zapatillas de correr" className="rounded-2xl shadow-lg w-full h-64 object-cover mt-8" data-id="element-202" />
                  <img src="https://images.unsplash.com/photo-1571019614242-c5c5dee9f50b?auto=format&fit=crop&w=600&q=80" alt="Entrenamiento" className="rounded-2xl shadow-lg w-full h-64 object-cover" data-id="element-203" />
                  <img src="https://images.unsplash.com/photo-1517836357463-d25dfeac3438?auto=format&fit=crop&w=600&q=80" alt="Gimnasio/Preparación" className="rounded-2xl shadow-lg w-full h-64 object-cover col-span-2 object-center" data-id="element-204" />
                </div>
              </div>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}